import FormInput from '../FormInput';
import PanelFooter from '../PanelFooter';
import DynamicParams from '../../UI/DynamicParams';
import { DYNAMIC_PARAMS, MAX_CHAR_LIMIT_75 } from '../../../utils/constants';
import { today } from '../../../utils/utils';

const PanelPush = (props) => {
  const { values, setValues: action, enums={ deepLinking: [], productType: []} } = props;

  const filteredDLOptions = enums.deepLinking 
  ? enums.deepLinking.filter(el => el.id !== 'DL_IOSI_PLUS_ACTIVATION' && el.id !== 'DL_IOSI_START_ACTIVATION') 
  : [];

  return (
    <>
  <form className="form-container">

      <div className="form-row">
        <FormInput
            type="text"
            name="titlePush"
            values={values}
            action={action}
            maxLength={MAX_CHAR_LIMIT_75}
          />
      </div>

      <div className="form-row">
        <FormInput
            type="textarea"
            name="textPush"
            values={values}
            action={action}
          />
      </div>

      <div className="form-row withparam">
        {
          [...Array(DYNAMIC_PARAMS)].map((el, i) =>
            <DynamicParams
              fieldNameToModify="textPush"
              index={i+1}
              values={values}
              action={action}
              label='PAR'
              identificator='%%'
            />
          )
        }
      </div>

      <div className="form-row">
        <FormInput
            type="text"
            name="imagePush"
            values={values}
            action={action}
          />
      </div>

      <div className="form-row form-row--double">
        <FormInput
            type="select"
            name="actionPush"
            values={values}
            action={action}
            options={filteredDLOptions}
          />
        <FormInput
            type="select"
            name="actionPushProducyType"
            values={values}
            action={action}
            options={enums.productType}
          />
      </div>

      <div className="form-row form-row--double">
        <FormInput
            type="date"
            name="persistenceNotificationDate"
            values={values}
            action={action}
            options={enums.productType}
            min={today()}
          />
      </div>

      <PanelFooter appConfig={props.appConfig} />
    </form>
  </>
);
}
export default PanelPush;
